import React from "react";
import styled from "styled-components";
import IconHdd from "../images/hdd.svg";
import IconHddSelected from "../images/hdd_selected.svg";

const Container = styled.div`
  text-align: center;
  padding: 8px;
  width: 100px;

  img {
    width: 55px;
    height: 60px;
    pointer-events: none;
  }

  p {
    display: inline-block;
    margin: 0;
    padding: 2px 4px;
    font-size: 14px;

    &.selected {
      color: #fff;
      background-color: #000;
    }
  }
`;

const Hdd = ({ title, manageWindow, manageSelection, selected }) => {
  const handleClick = () => {
    manageSelection(title);
  }

  return (
    <Container
      onClick={handleClick}
      onDoubleClick={() => {
        manageWindow(title, true);
      }}
    >
      <img src={selected?IconHddSelected:IconHdd} alt={title} />
      <p className={selected?"selected":""}>{title}</p>
    </Container>
  );
};

export default Hdd;
